import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.member.profile');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-member-profile',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.member.profile/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalMemberProfileComponent implements OnInit {
    public user: any = null;
    public saving: boolean = false;
    public tab: string = 'profile';

    public passwordForm: any = { current_password: '', new_password: '', confirm_password: '' };
    public changingPassword: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const params = new URLSearchParams();
        try {
            const res = await fetch('/api/member/me', { method: 'POST', body: params });
            const result = await res.json();
            if (res.ok) {
                this.user = result.data;
            }
        } catch (e) { }
        await this.service.render();
    }

    public async switchTab(tab: string) {
        this.tab = tab;
        await this.service.render();
    }

    public async updateProfile() {
        if (!this.user.name) {
            await this.service.modal.error("이름을 입력해주세요.");
            return;
        }
        this.saving = true;
        await this.service.render();

        const params = new URLSearchParams();
        params.append('name', this.user.name);
        params.append('mobile', this.user.profile?.mobile || '');
        params.append('department', this.user.profile?.department || '');
        params.append('position', this.user.profile?.position || '');
        params.append('bio', this.user.profile?.bio || '');

        try {
            const res = await fetch('/api/member/update-profile', { method: 'POST', body: params });
            const result = await res.json();
            if (res.ok) {
                await this.service.modal.success("프로필이 업데이트되었습니다.");
            } else {
                await this.service.modal.error(result.message || "업데이트 실패");
            }
        } catch (e) {
            await this.service.modal.error("서버 오류");
        }

        this.saving = false;
        await this.service.render();
    }

    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;
        if (!current_password) { await this.service.modal.error("현재 비밀번호를 입력해주세요."); return; }
        if (!new_password || new_password.length < 8) { await this.service.modal.error("새 비밀번호는 8자 이상이어야 합니다."); return; }
        if (new_password !== confirm_password) { await this.service.modal.error("비밀번호가 일치하지 않습니다."); return; }

        this.changingPassword = true;
        await this.service.render();

        const params = new URLSearchParams();
        params.append('current_password', current_password);
        params.append('new_password', new_password);

        try {
            const res = await fetch('/api/auth/change-password', { method: 'POST', body: params });
            const result = await res.json();
            if (res.ok) {
                await this.service.modal.success("비밀번호가 변경되었습니다.");
                this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
            } else {
                await this.service.modal.error(result.message || "변경 실패");
            }
        } catch (e) {
            await this.service.modal.error("서버 오류");
        }

        this.changingPassword = false;
        await this.service.render();
    }
}

export default PortalMemberProfileComponent;